import React from 'react';
import LocalizedMessage from 'common/localized-message';

const CreateHighlightMessage = (props) => {
  return (
    <div className="tab-blank-state">
      <h1><LocalizedMessage id={'profiles.highlightcta.get_started_now'}/></h1>
      <div className="image-group">
        <figure>
          <img src="https://static.hudl.com/profiles/images/highlights/mark-highlight_2x.png"/>
          <figcaption>
            <LocalizedMessage id={'profiles.highlightcta.awesome_plays'}/>
          </figcaption>
        </figure>
        <figure>
          <img src="https://static.hudl.com/profiles/images/highlights/add-spot-shadow_2x.png"/>
          <figcaption>
            <LocalizedMessage id={'profiles.highlightcta.outstanding_effects'}/>
          </figcaption>
        </figure>
        <figure>
          <img src="https://static.hudl.com/profiles/images/highlights/save-highlight_2x.png"/>
          <figcaption>
            <LocalizedMessage id={'profiles.highlightcta.public_to_world'}/>
          </figcaption>
        </figure>
      </div>

      <p>
        <LocalizedMessage id={'profiles.highlightcta.info_one'}/><br/>
        <LocalizedMessage id={'profiles.highlightcta.info_two'}/><br/>
        <LocalizedMessage id={'profiles.highlightcta.info_three'}/>
      </p>

      <br/>
      <a className="uni-btn uni-btn--primary uni-btn--small" href={props.libraryUrl}>
        <LocalizedMessage id={'profiles.highlightcta.button_primary'}/>
      </a>
      <br/>
      <br/>
      <a className="uni-btn uni-btn--subtle uni-btn--small" href={props.highlightSupportUrl}>
      <LocalizedMessage id={'profiles.highlightcta.button_secondary'}/>
      </a>
    </div>
  );
};

CreateHighlightMessage.propTypes = {
  highlightSupportUrl: React.PropTypes.string.isRequired,
  libraryUrl: React.PropTypes.string.isRequired,
};

export default CreateHighlightMessage;
